export default __webpack_public_path__ + "static/iso-27001-537df5229c45711c0bd11e4ba50643a1.svg";